<p-fluid>
  <div [class.xofmanyrequired]="isOneOfManyRequired() && xOfManyErrors()" class="w-100">
    <p-autoComplete [(ngModel)]="selectedAccountCategory" #accountCategorySelection="ngModel" name="accountCategorySelection"
      [suggestions]="accountCategorySuggestions"
      (completeMethod)="onComplete($event)"
      (onBlur)="onBlur()"
      emptyMessage="No Account Categories Found"
      optionLabel="displayText"
      [dropdown]="true"
      [forceSelection]="forceSelection()"
      [placeholder]="placeholder"
      [attr.required]="required()"
      [required]="required() && !isOneOfManyRequired()"
      [disabled]="disabled"
      [styleClass]="styleClass()"
      [appendTo]="appendTo()"
      (onClear)="clearAccountCategory()" (onFocus)="onFocus()" (onSelect)="onSelect()" [group]="false" />
  </div>
  <error-message [errorControl]="accountCategorySelection">
    @if (accountCategorySelection?.errors?.required) {
      <span>Please select an Account Category to continue.</span>
    }
  </error-message>
</p-fluid>
